// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"c7462688","412":"c7462688"}[chunkId] + ".chunk.css";
};